<script setup lang="ts">
import { tpgIconRefresh } from '@tpg/grammar-web-icons';

import { GrammarPrimaryButton, GrammarText } from '@nora-monorepo/grammar-ui';

interface ErrorScreenProps {
  title: string;
  message?: string;
  showReload?: boolean;
}

withDefaults(defineProps<ErrorScreenProps>(), {
  message: '',
  showReload: false,
});

function reload(): void {
  window.location.reload();
}
</script>

<template>
  <div
    class="flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center bg-light-bg-primary dark:bg-dark-bg-primary"
  >
    <GrammarText
      :text="title"
      size="large"
      class="font-semibold"
    />

    <p
      v-if="message"
      class="max-w-md text-light-label-secondary dark:text-dark-label-secondary"
    >
      {{ message }}
    </p>

    <GrammarPrimaryButton
      v-if="showReload"
      class="mt-2"
      label="Reload"
      :icon-template="tpgIconRefresh"
      icon-position="trailing"
      @click="reload"
    />
  </div>
</template>
